import Spinner from "components/atoms/Spinner";

const FullPageSpinner = () => {
  return <div className="flex w-full h-full items-center justify-center">
    <Spinner/>
  </div>;
};

export default FullPageSpinner;